/**
 * Shop limitations types enum
 * @readonly
 * @enum {string}
 */
export const LIMITATION_TYPE_ENUM = {
  brandFree: "brand_free",
  reviewLikeDislike: "reviews_likes",
  reviewsSorting: "reviews_sorting",
  shopAnswers: "shop_answer",
  reivewsPhoto: "reviews_photos",
  contactFields: "contact_fields",
};
